import { type InjectionKey } from 'vue';
import type { AccountPanel } from '~/types';

export const AccountPanelKey: InjectionKey<AccountPanel> = Symbol.for('AccountPanelKey');

// Panel state is created per Nuxt app instance: per request on the server,
// once per session on the client. A module-scope reactive would be shared by
// every SSR request for the lifetime of the server process.
export function useAccountPanelState(): AccountPanel {
    const nuxtApp = useNuxtApp() as unknown as { _accountPanelState?: AccountPanel };

    nuxtApp._accountPanelState ??= reactive<AccountPanel>({
        isFullWidth: true,
        showSideNav: true
    });

    return nuxtApp._accountPanelState;
}

export function useAccountPanel(): Undefinable<AccountPanel> {
    const accountPanelInject = inject(AccountPanelKey);
    return accountPanelInject;
}
